import { FC, memo } from 'react';
import { VscTriangleDown, VscTriangleUp } from 'react-icons/vsc';
import { Flex, Icon } from '@chakra-ui/react';
import { SortDirection } from '@tanstack/react-table';

const TableSortIconComponent: FC<{
  isActive: boolean;
  direction: SortDirection | false;
}> = ({ isActive, direction }) => {
  if (!isActive) {
    return (
      <Flex direction="column">
        <Icon as={VscTriangleDown} color="gray.500" />
      </Flex>
    );
  }

  if (direction === 'asc') {
    return (
      <Flex direction="column">
        <Icon
          aria-label="sorted ascending"
          as={VscTriangleUp}
          color="primary.500"
        />
      </Flex>
    );
  }

  return (
    <Flex direction="column">
      <Icon
        aria-label="sorted descending"
        as={VscTriangleDown}
        color="primary.500"
      />
    </Flex>
  );
};

export const TableSortIcon = memo(TableSortIconComponent);
